Namespace 'AccountSettings.OperatorStatus'

class AccountSettings.OperatorStatus.ModalBodyView extends Backbone.View
  template: JST["backbone/templates/account_settings/operator_statuses/modal_body"]

  initialize: (options) ->
    @options = options
    @containerClass = options.modal.containerClass

    @operatorStatusNameView = new AccountSettings.OperatorStatus.OperatorStatusNameView(options.statusName);
    @operatorStatusTypeView = new AccountSettings.OperatorStatus.OperatorStatusTypeView(options.statusType);
    @timeoutCheckView = new AccountSettings.OperatorStatus.TimeoutEnabledCheckboxView(options.timeoutCheck);
    @timeoutCounterView = new AccountSettings.OperatorStatus.TimeoutCounterView(options.timeoutCounter);
    @unassignTicketsCheckView = new AccountSettings.OperatorStatus.UnassignTicketsCheckboxView(options.unassignTickets);
    @operatorStatusDefaultView = new AccountSettings.OperatorStatus.OperatorStatusDefaultView(options.defaultCheck);

    @listenTo(@timeoutCheckView, 'timeout:enabled:changed', @onTimeoutCheck)
    super

  render: =>
    @$el.html(@template(containerClass: @containerClass))
    @$el.find(@options.statusName.parent).html(@operatorStatusNameView.render().el)
    @$el.find(@options.statusType.parent).html(@operatorStatusTypeView.render().el)
    @$el.find(@options.timeoutCheck.parent).html(@timeoutCheckView.render().el)
    @$el.find(@options.timeoutCounter.parent).html(@timeoutCounterView.render().el)
    @$el.find(@options.defaultCheck.parent).html(@operatorStatusDefaultView.render().el)
    @$el.find(@options.unassignTicketsCheck.parent).html(@unassignTicketsCheckView.render().el)
    @

  onTimeoutCheck: (state) =>
    @timeoutCounterView.onTimeoutCheck(state)

  setState: (state) =>
    @operatorStatusNameView.setName(state.statusName)
    @operatorStatusTypeView.setSelectedType(state.statusType)
    @operatorStatusTypeView.setSelectedDisabled(state.statusTypeDisabled)
    @timeoutCheckView.setCheckState(state.timeoutEnabled)
    @timeoutCounterView.setDisabled(!state.timeoutEnabled)
    @timeoutCounterView.setCounter(state.timeoutCounter)
    @operatorStatusDefaultView.setCheckState(state.defaultStatus)
    @operatorStatusDefaultView.setNullStatus(state.nullStatus)
    @unassignTicketsCheckView.setCheckState(state.unassignTickets)
    @render()

  resetState: =>
    @timeoutCheckView.setCheckState(false)

  showComponents: =>
    @operatorStatusTypeView.show()
    @timeoutCheckView.show()
    @timeoutCounterView.show()
    @operatorStatusDefaultView.show()

  hideComponentsForNullStatus: =>
    @operatorStatusTypeView.hide()
    @timeoutCheckView.hide()
    @timeoutCounterView.hide()
    @operatorStatusDefaultView.hide()

  showUnassignTickets: =>
    @unassignTicketsCheckView.show()

  hideUnassignTickets: =>
    @unassignTicketsCheckView.hide()
